import $http from '@Config/axios';
import { DefaultPresenter } from '@Presenter/default-presenter';

const prefix = 'sache';
const entity = 'Sache';

export const SachePresenter = {
	...DefaultPresenter({ prefix, entity })
};
